







import { PartnerPractice } from '@/shared/partner-practice';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');

@Component
export default class OriginalSourceSelect extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;
    @partnerPracticesModule.Getter('partnerPracticeOriginalSourceTypes') private originalSourceTypes!: (partnerPracticeId: string | null) => Array<ClientOriginalSourceType>;
    @Prop({ required: true }) private value!: string | null;
    @Prop({ required: true }) private partnerPracticeId!: string | null;

    private input: string | null = this.value;

    private get options(): Array<{}> {
        const options = this.originalSourceTypes(this.partnerPractices.length === 1 ? this.partnerPractices[0].id! : this.partnerPracticeId)
            .map((type) => {
                return {
                    value: type.id!,
                    text: type.value,
                };
            });

        return [
            { value: null, text: 'All' },
            ...options,
        ];
    }

    @Watch('value')
    private onValueChanged(value: string | null): void {
        this.input = value;
    }

    @Watch('partnerPracticeId')
    private onPartnerPracticeIdChanged(): void {
        this.input = null;
    }

    @Watch('input')
    private onInputChanged(): void {
        this.$emit('input', this.input);
    }
}
